//#region src/tenants/skylight/routing.ts
/**
* Skylight provider ranking. Agent workflow rules live in
* packages/services/src/harnesses/skylight/workflow.ts.
*
* Skylight is the one tenant on compositeKeys. Its referral order — whoever
* staff asked for, then CCA partners, then in-network, then independents by
* quality with health systems last, then the department's city preference —
* needs every key to survive as a tiebreak. sequentialOverwrite cannot express
* it at all: each step re-sorts the whole array and resolves ties by provider
* name, so appending CCA and quality would discard the location rank and
* prepending them would let location discard the CCA rank.
*
* The three priority keys are unseeded today, so every provider scores the
* same on them and the order is the same one sequentialOverwrite produced.
* They start ordering the moment Skylight supplies the data. Note that
* insurance sits above location here, the reverse of HHB — that becomes
* visible when AZ payor acceptance lands. See specs/provider-priority-ranking.md.
*
* HHB and Demo stay on sequentialOverwrite. Do not "unify" these.
*/
const skylightProviderRouting = { ranking: {
	mode: "compositeKeys",
	keys: [
		"providerName",
		"organizationName",
		"cca",
		"insurance",
		"ownership",
		"qualityTier",
		"location"
	]
} };

//#endregion
export { skylightProviderRouting };